import { State } from '@ddt-web/store-service';
import * as isEmpty from 'lodash/isEmpty';
import * as keyBy from 'lodash/keyBy';
import * as map from 'lodash/map';
import * as mapValues from 'lodash/mapValues';


/**
 * Transform the API Response to store structure.
 * Can be Used for test cases' mocks
 * @param responseJson api response.
 * @return the store structured data.
 */
export class ApiResponseTransformUtil {
	public static transformResponseToStoreData(responseJson: Object[]): State<Object> {
		const storeData: State<Object> = { ids: [], entities: {}, isLoading: false };
		if (!isEmpty(responseJson)) {
			Object.assign(storeData, {
				ids: map(responseJson, 'id'),
				entities: mapValues(keyBy(responseJson, 'id'), res => res),
				isLoading: false
			});
		}
		return storeData;
	}
}
